import * as React from "react";
import { useFieldProps } from "src/hooks/form/useField";
import { useStaticRadio } from "src/hooks/form/useRadio";
import { useReduxState } from "src/hooks/useRedux";

const useServices = <T>(
  props: useFieldProps<T>,
  defaultType: "FCL" | "LCL" | "AIRCARGO"
) => {
  const field = useStaticRadio<ReturnType<typeof getOptions>, T>(props);
  const [type, setType] = React.useState(defaultType);
  const servicesMapping = useReduxState(["masterData", "execution", "shippingModeToValidServicesMapping"]).value;

  React.useEffect(() => {
    field.reset();
    field.setOptionsData(getOptions(), (data) => {
      return data ? data?.map((el) => ({
        key: el,
        label: el,
      })) : [];
    });
  }, [servicesMapping, type]);

  const getOptions = () => {
    return servicesMapping[type];
  };

  return {
    ...field,
    setType,
  };
};

export default useServices;
